module.exports = __webpack_public_path__ + "img/svg10.06ec593c.svg";